import React from 'react'

import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'

import Select, {
	type SelectChangeEvent,
} from '../formControls/Select'
import { LabelValuePair } from '../../types'
import useRoleList from '../../hooks/useRoleList'
import FormControl from '../formControls/FormControl'
import type { UserRole } from '../modals/ModalShareLoan'
import { addSpacesToPascalCase } from '../../services/helpers'
import getAllowedRolesForUser from '../../utils/rolePermissions'

type ShareLoanAssignedRoleCellProps = {
	row: UserRole
	userId: string
	isSubmitting?: boolean
	showRolesBasedOnUserRole?: boolean
	onChangeRoleItem?: (
		e: SelectChangeEvent<unknown>,
		userId: string
	) => void
}

const ShareLoanAssignedRoleCell = ({
	row,
	userId,
	isSubmitting,
	showRolesBasedOnUserRole,
	onChangeRoleItem,
}: ShareLoanAssignedRoleCellProps) => {
	const disabledSelect =
		row.loadingRevoke ||
		row.loadingEdit ||
		row.user.id === userId ||
		isSubmitting

	const allowedRoles =
		showRolesBasedOnUserRole && row.user?.role
			? getAllowedRolesForUser(row.user.role)
			: undefined

	const roleOptionList = useRoleList({
		includeRoles: allowedRoles,
	})

	if (row.markedForDeletion)
		return (
			<Typography
				variant="body2"
				style={{
					opacity: 0.5,
					textDecoration: 'line-through',
				}}
			>
				{addSpacesToPascalCase(row.assignedRole)}
			</Typography>
		)

	return (
		<FormControl
			size="small"
			sx={{
				display: 'flex',
				flexDirection: 'row',
				gap: 2,
				alignItems: 'center',
				paddingTop: '20px',
			}}
		>
			<Select<LabelValuePair>
				size="small"
				menuItems={roleOptionList}
				disabled={disabledSelect}
				selectProps={{
					value: row.assignedRole,
					onChange: (e: SelectChangeEvent<unknown>) =>
						onChangeRoleItem?.(e, row.user.id),
				}}
				sx={{ width: 220 }}
			/>

			{row.loadingEdit && (
				<CircularProgress size={20} sx={{ mb: 2 }} />
			)}
		</FormControl>
	)
}

export default ShareLoanAssignedRoleCell
